<template>
  <div id="Debug">
    <div class="media-video background-image-cover" :style="{ backgroundImage: `url(${course.cover})` }">
      <MediaPlayer
        v-if="course.pkid"
        :onlineMemberNum="chat.onlineMemberNum"
        :courseId="courseId"
        :cover="course.cover"
        :startTime="course.startTime"
        :channel="course.channel"
        :state="course.state"
        :expectStartTime="course.expectStartTime"
      ></MediaPlayer>
    </div>
    <main>
      <div class="course-detail" :style="courseDetailStyle">
        <p class="title">{{ course.title }}</p>
        <p class="time">{{ course.dateString }}</p>
        <VuiButton v-if="course.state === COURSE_STATE.FORECAST" class="signup" :type="course.signUpFlag ? 'cancel' : 'warning'" size="large" round long @click.native="setCourseSingup">
          {{ course.signUpFlag ? '已报名' : '我要报名' }}
        </VuiButton>
        <p class="info" ref="info" :style="{ 'max-height': (course.showAllInfo ? '' : `${course.maxHeight}px`) }">{{ course.info }}</p>
        <VuiButton class="btn" type="text" @click.native="course.showAllInfo = !course.showAllInfo" v-if="course.needShowAllBtn">
          {{ course.showAllInfo ? '收起' : '查看全部' }}
        </VuiButton>
      </div>
      <transition name="scale-up-center">
        <div class="chatroom-msgs" :style="chatroomMsgsStyle" v-if="chat.showChatroomMsgs" @click="closeChatroomOther">
          <VuiButton class="close-chat" size="large" long @click.native="chat.showChatroomMsgs = false">
            <span>收起</span>
            <vui-ico class="ico-close-chat ibang-arrow-bottom" :w="16"></vui-ico>
          </VuiButton>
          <div class="tabs">
            <VuiButton class="tab" type="text" :class="{ active: chat.nowTab === 'chat' }" @click.native="chat.nowTab = 'chat'">聊天</VuiButton>
            <VuiButton class="tab" type="text" :class="{ active: chat.nowTab === 'member' }" @click.native="chat.nowTab = 'member'">成员（{{ chat.members.length }}）</VuiButton>
          </div>
          <div class="member" v-show="chat.nowTab === 'member'">
            <div class="member-item" v-for="v in chat.members" :key="v.account">
              <img :src="v.avatar">
              <p class="name">{{ v.nick }}</p>
              <p class="time">{{ v.enterTimeString }}</p>
            </div>
          </div>
          <VuiScroll v-show="chat.nowTab === 'chat'" class="chatroom" ref="chatroom" :topLoad="getHistoryMsgs">
            <div v-for="v in chat.msgs" :key="v.time" class="msg" :class="{ self: v.isSelf }">
              <img class="avatar" :src="v.fromAvatar || `/img/avatar-male.svg`">
              <p class="username">{{ v.isSelf ? `${v.timeString} ${v.fromNick}` : `${v.fromNick} ${v.timeString}` }}</p>
              <template v-if="v.type === 'text'"><p class="content">{{ v.text }}</p></template>
              <template v-if="v.type === 'custom' && v.content.type === 'expression'"><img class="expression" :src="`/img/expression/${expressionTable[v.content.id]}`"></template>
              <template v-if="v.type === 'custom' && v.content.type === 'gift'">
                <p class="content gift-name">
                  <span>{{ `送出了${giftTable[v.content.id].name}` }}</span>
                  <img class="gift" :src="`/img/gift/${giftTable[v.content.id].src}`">
                </p>
              </template>
            </div>
          </VuiScroll>
          <VuiSpin v-if="chat.chatroomIsLoading"></VuiSpin>
        </div>
      </transition>
      <div class="chatroom-input" :style="chatroomInputStyle" ref="chatroomInput" @click="chat.nowTab = 'chat'">
        <textarea
          v-if="course.state === COURSE_STATE.LIVING"
          spellcheck="false"
          placeholder="发表评论 ~"
          ref="chatroomInputBox"
          v-model="chat.inputMsg"
          @click="openChatroomMsgs"
          @keydown.enter="sendMsg"
          @focus="closeChatroomOther"
        ></textarea>
        <p class="tip-text" v-if="course.state === COURSE_STATE.FORECAST">直播尚未开始，暂时不能评论 ~</p>
        <p class="tip-text" v-if="course.state === COURSE_STATE.ENDED">直播已经结束，不能评论 ~</p>
        <template v-if="course.state === COURSE_STATE.LIVING && chat.showChatroomMsgs">
          <img class="ico" v-if="chat.showChatroomExpression" src="@/assets/svg/icon-keyboard.svg" @click="openChatroomKeyboard">
          <img class="ico" v-else src="@/assets/svg/icon-emoji.svg" @click="openChatroomExpression">
          <img class="ico" src="@/assets/svg/icon-gift.svg" @click="openChatroomGift">
        </template>
        <template v-else>
          <img class="ico" src="@/assets/svg/icon-chatting.svg" @click="openChatroomMsgs">
          <span class="msgsnum" @click="openChatroomMsgs">{{ chat.msgsnum }}</span>
        </template>
        <VuiSpin v-if="chat.chatroomIsLoading"></VuiSpin>
      </div>
      <div v-if="chat.showChatroomExpression" class="chatroom-expression" ref="chatroomExpression">
        <img v-for="(v, k) in expressionTable" :key="k" :src="`/img/expression/${v}`" @click="sendExpression(k)">
      </div>
      <transition name="scale-up-center">
        <div class="chatroom-gifts" v-if="chat.showChatroomGift">
          <VuiButton type="text" long @click.native="chat.showChatroomGift = false"><img src="@/assets/svg/icon-back.svg"></VuiButton>
          <div class="gift-list">
            <div class="gift-item" v-for="(v, k) in giftTable" :key="k">
              <img :src="`/img/gift/${v.src}`" :class="{ active: chat.activeGift === k }" @click="chat.activeGift = k">
              <p class="name">{{ v.name }}</p>
            </div>
          </div>
          <div class="control">
            <p class="time">{{ chat.countdownNowTimeString }}</p>
            <VuiButton type="warning" class="btn-send" :disabled="!(chat.allowSendGift && chat.activeGift)" @click.native="sendGift">发送</VuiButton>
          </div>
        </div>
      </transition>
      <div v-if="!isLogin" class="need-login">
        <span class="text">解锁聊天室和直播</span>
        <VuiButton type="warning" round @click.native="$router.push({ name: 'Login' })">登录</VuiButton>
      </div>
    </main>
    <i-rate :showStar.sync="showStar" @submitRate="submitRate"></i-rate>
  </div>
</template>

<script>
import VuiScroll from '@/components/ui/Scroll'
import MediaPlayer from '@/components/business/DebuggingPlayer'
import IRate from '@/components/business/IRate'
import { dateStringFrom } from '@/utils'
import { COURSE_STATE } from '@/constant/constants'
let nimInstance = null
let chatroomInstance = null

export default {
  name: 'Debug',
  components: {
    VuiScroll,
    MediaPlayer,
    IRate,
  },
  data () {
    return {
      appKey: this.$config.appKey,
      showStar: false,
      course: {
        title: '',
        cover: '',
        channel: '',
        startTime: -1,
        endTime: -1,
        expectStartTime: -1,
        expectTime: -1,
        signUpFlag: false,
        info: '',
        state: -1,
        chatGroup: '',
        dateString: '',
        allowMaxHeight: 80,
        maxHeight: '',
        needShowAllBtn: false,
        showAllInfo: true,
      },
      chat: {
        inputMsg: '',
        chatroomIsLoading: true,
        showChatroomMsgs: false,
        showChatroomExpression: false,
        showChatroomGift: false,
        chatroomInputHeight: 44,
        chatroomExpressionHeight: 160,
        msgs: [],
        members: [],
        nowTab: 'chat', // 'chat' | 'member'
        msgsnum: 0,
        onlineMemberNum: 0,
        valid: false,
        activeGift: '',
        countdownStartTime: -1,
        countdownNowTimeString: '',
        allowSendGift: false,
      },
      expressionTable: {
        i001: 'emoji-thumb@3x.png',
        i002: 'emoji-cool@3x.png',
        i003: 'emoji-kiss@3x.png',
        i004: 'emoji-struggle@3x.png',
        i005: 'emoji-goofy@3x.png',
        i006: 'emoji-doubt@3x.png',
        i007: 'emoji-crying@3x.png',
        i008: 'emoji-smile@3x.png',
      },
      giftTable: {
        i009: { name: '玫瑰花', src: 'gift-rose@3x.png' },
        i010: { name: '小心心', src: 'gift-heart@3x.png' },
        i011: { name: '小橙橙', src: 'gift-orange@3x.png' },
        i012: { name: '奖杯', src: 'gift-trophy@3x.png' },
      },
      COURSE_STATE,
    }
  },
  watch: {
    'chat.chatroomIsLoading' (val) {
      if (val === true) {
        this.closeChatroomOther()
      }
    },
  },
  computed: {
    isLogin () {
      return this.$store.state.app.isLogin
    },
    courseId () {
      return this.$route.params.courseId
    },
    accid () {
      return this.$store.state.chat.accid
    },
    token () {
      return this.$store.state.chat.token
    },
    courseDetailStyle () {
      return this.chatroomMsgsStyle
    },
    chatroomMsgsStyle () {
      return {
        bottom: this.chat.showChatroomExpression
          ? `${this.chat.chatroomInputHeight
              + this.chat.chatroomExpressionHeight}px`
          : `${this.chat.chatroomInputHeight}px`,
      }
    },
    chatroomInputStyle () {
      return {
        bottom: this.chat.showChatroomExpression
          ? `${this.chat.chatroomExpressionHeight}px`
          : 0,
      }
    },
  },
  methods: {
    // 尽量保证页面主体在居中位置：Only Web
    adjustPosition (reset) {
      if (reset) {
        this.$store.commit('app/positionHeader', {
          marginTop: this.$cacheHeaderMarginTop || 0,
        })

        return
      }

      const header = document.querySelector('#Header')
      const detail = document.querySelector('#Detail')
      const headerHeight = header.getBoundingClientRect().height
      const detailHeight = detail.getBoundingClientRect().height
      const windowHeight = window.innerHeight

      if (headerHeight * 2 + detailHeight < windowHeight) {
        // 如果有剩余空间就使它居中
        this.$cacheHeaderMarginTop = this.$store.state.app.headerMarginTop
        this.$store.commit('app/positionHeader', {
          marginTop: (windowHeight - detailHeight) / 2 - headerHeight,
        })
      }
    },
    // 处理 info 内容显示逻辑
    updateInfoStatus () {
      // 先充分让其占满空间，然后进行高度测量
      this.course.showAllInfo = true
      this.course.maxHeight = ''
      this.$nextTick(() => {
        const { height } = this.$refs.info.getBoundingClientRect()

        if (height > this.course.allowMaxHeight) {
          // 如果 当前高度 > 最大允许高度，展示折叠按钮并进行折叠
          this.course.needShowAllBtn = true
          this.course.showAllInfo = false
          this.course.maxHeight = this.course.allowMaxHeight
        } else {
          // 如果 当前高度 <= 最大允许高度，取消折叠按钮并展开
          this.course.needShowAllBtn = false
          this.course.showAllInfo = true
        }
      })
    },
    // 更改课程的报名状态
    setCourseSingup () {
      if (!this.isLogin) {
        this.$Message.info('请先登录！')
        return
      }

      this.$store
        .dispatch('course/setCourseSingup', {
          courseId: this.courseId,
          signUpFlag: !this.course.signUpFlag,
        })
        .then(() => {
          this.course.signUpFlag = !this.course.signUpFlag
          this.$Message.info(this.course.signUpFlag ? '报名成功' : '取消成功')
        })
        .catch(() => {
          this.$Message.info(this.course.signUpFlag ? '取消失败' : '报名失败')
        })
    },
    // 打开聊天室并滚动到底部
    openChatroomMsgs () {
      if (this.course.state === COURSE_STATE.LIVING || this.course.state === COURSE_STATE.ENDED) {
        if (!this.chat.showChatroomMsgs) {
          this.chat.showChatroomMsgs = true
          this.chatroomScrollToBottom()
        }
      }
    },
    // 打开表情界面
    openChatroomExpression () {
      this.chat.showChatroomGift = false
      this.chat.showChatroomExpression = true
      this.chatroomScrollToBottom()
    },
    // 打开礼物界面
    openChatroomGift () {
      this.chat.showChatroomExpression = false
      this.chat.showChatroomGift = true
    },
    // 打开键盘界面
    openChatroomKeyboard () {
      this.$refs.chatroomInputBox.focus()
    },
    // 关闭聊天室的其他界面
    closeChatroomOther () {
      this.chat.showChatroomExpression = false
      this.chat.showChatroomGift = false
    },
    // 聊天室滚动到最底部
    chatroomScrollToBottom () {
      if (this.chat.showChatroomMsgs) {
        this.$nextTick(() => {
          const chatroom = this.$refs.chatroom.$el
          const chatroomrHeight = chatroom.getBoundingClientRect().height

          chatroom.scrollTop = chatroom.scrollHeight - chatroomrHeight
        })
      }
    },
    // 开始倒计时
    startCountdown () {
      setTimeout(() => {
        const tenMinutesValue = 60 * 1000
        const sum = Math.floor(
          (tenMinutesValue + this.chat.countdownStartTime - Date.now()) / 1000
        )

        if (sum < 0) {
          this.chat.countdownNowTimeString = '快给老师送个礼物吧！'
          this.chat.allowSendGift = true
          return
        }

        const m = Math.floor(sum / 60)
        const s = sum % 60

        this.chat.countdownNowTimeString = `${m < 10 ? '0' : ''}${m}:${
          s < 10 ? '0' : ''
        }${s} 后可发送礼物`

        this.startCountdown()
      }, 1000)
    },
    // 发送评分
    submitRate ({ rate, evaluate }) {
      this.$store
        .dispatch('course/setCourseCommend', {
          content: evaluate,
          evaluate: rate,
          targetId: this.courseId,
          targetType: 1,
        })
        .then(() => {
          this.$Message.info('评价成功!')
        })
    },
    // 获取课程详情
    getCourseDetail () {
      this.$store
        .dispatch('course/getCourseDetail', { courseId: this.courseId })
        .then(course => {
          Object.assign(this.course, course)
          this.updateInfoStatus()

          if (this.isLogin) {
            this.getSelfInfo()
          }
        })
        .catch(() => {
          this.$Message.error('获取课程详情失败！')
        })
    },
    // 从云信获取用户信息
    getSelfInfo () {
      this.$store
        .dispatch('chat/getSelfInfo')
        .then(() => {
          this.initNim()
          this.initChatroom()
        })
        .catch(() => {
          console.log('<<<< 从云信获取用户信息失败 >>>>')
        })
    },
    // 初始化 NIM 以接收自定义系统通知
    initNim () {
      nimInstance = window.SDK.NIM.getInstance({
        appKey: this.appKey,
        account: this.accid,
        token: this.token,
        onconnect: () => {
          console.log('<<<< 云信连接成功 >>>>')
        },
        oncustomsysmsg: ({ content }) => {
          try {
            content = JSON.parse(content)

            const { type, courseId, valid, channel } = content

            if (type === 2 && courseId === this.courseId) {
              this.course.channel = channel

              if (valid === true) {
                this.course.state = COURSE_STATE.LIVING
              }

              if (valid === false) {
                this.course.state = COURSE_STATE.ENDED
                this.showStar = true
              }
            }
          } catch (err) {}
        },
      })
    },
    // 初始化 Chatroom
    initChatroom () {
      this.$store
        .dispatch('chat/getChatroomAddress', {
          roomid: this.course.chatGroup,
          accid: this.accid,
        })
        .then(address => {
          chatroomInstance = window.SDK.Chatroom.getInstance({
            appKey: this.appKey,
            account: this.accid,
            token: this.token,
            chatroomId: this.course.chatGroup,
            chatroomAddresses: address,
            onmsgs: this.chatroomOnMsgs,
            onconnect: () => {
              console.log('<<<< 聊天室连接成功 >>>>')

              Promise.all([
                this.getHistoryMsgs(true),
                this.getMsgNum(),
                this.getChatroomInfo(),
                this.getChatroomMembers(),
              ])
                .then(() => {
                  if (this.chat.countdownStartTime === -1) {
                    this.chat.countdownStartTime = Date.now()
                    this.startCountdown()
                  }

                  this.chat.chatroomIsLoading = false
                })
                .catch(() => {
                  console.log(
                    '<<<< 获取 “历史消息 | 消息总数 | 在线人数” 失败 >>>>'
                  )
                })
            },
            onwillreconnect: () => {
              console.log('<<<< YunXin will reconnect. >>>>')
              this.chat.chatroomIsLoading = true
            },
            ondisconnect: () => {
              console.log('<<<< YunXin is disconnect. >>>>')
              this.chat.chatroomIsLoading = true
            },
            onerror: () => {
              console.log('<<<< YunXin have a error. >>>>')
            },
          })
        })
        .catch(() => {
          console.log('<<<< 获取聊天室地址失败 >>>>')
        })
    },
    // 获取历史消息
    getHistoryMsgs (refresh) {
      return new Promise((resolve, reject) => {
        chatroomInstance.getHistoryMsgs({
          timetag: this.chat.msgs[0] && this.chat.msgs[0].time,
          limit: 50,
          msgTypes: ['text', 'custom'],
          done: (err, { msgs }) => {
            if (err) {
              reject(err)
              return
            }

            resolve()

            const result = []

            msgs = msgs.forEach(msg => {
              msg.isSelf = msg.from.toUpperCase() === this.accid.toUpperCase()
              msg.timeString = dateStringFrom('hh:mm:ss', msg.time)

              if (msg.type === 'text') {
                result.push(msg)
              }

              if (msg.type === 'custom') {
                msg.content = JSON.parse(msg.content)

                const { type, id } = msg.content

                if (type === 'expression' && id) {
                  result.push(msg)
                }

                if (type === 'gift' && id) {
                  result.push(msg)
                }
              }
            })

            if (refresh) {
              this.chat.msgs = []
            }

            this.chat.msgs.unshift(...result.reverse())
          },
        })
      })
    },
    // 获取消息总数
    getMsgNum () {
      return this.$store
        .dispatch('chat/getMsgNum', {
          roomid: this.course.chatGroup,
        })
        .then(msgsnum => {
          this.chat.msgsnum = msgsnum
        })
    },
    // 获取聊天室在线人数
    getChatroomInfo () {
      return new Promise((resolve, reject) => {
        chatroomInstance.getChatroom({
          done: (err, { chatroom }) => {
            if (err) {
              reject(err)
              return
            }

            this.chat.onlineMemberNum = chatroom.onlineMemberNum
            resolve()
          },
        })
      })
    },
    // 获取聊天室在线成员列表
    getChatroomMembers () {
      return new Promise((resolve, reject) => {
        chatroomInstance.getChatroomMembers({
          guest: true,
          onlyOnline: true,
          done: (err, { members }) => {
            if (err) {
              reject(err)
              return
            }

            members.forEach(member => {
              member.enterTimeString = dateStringFrom('hh:mm:ss', member.enterTime)
            })

            this.chat.members = members
            resolve()
          },
        })
      })
    },
    // 聊天室收到消息的回调
    chatroomOnMsgs (msgs) {
      const result = []

      msgs = msgs.forEach(msg => {
        msg.isSelf = msg.from.toUpperCase() === this.accid.toUpperCase()
        msg.timeString = dateStringFrom('hh:mm:ss', msg.time)

        if (msg.type === 'text') {
          result.push(msg)
        }

        if (msg.type === 'custom') {
          msg.content = JSON.parse(msg.content)

          const { type, id } = msg.content

          if (type === 'expression' && id) {
            result.push(msg)
          }

          if (type === 'gift' && id) {
            result.push(msg)
          }
        }

        if (msg.type === 'notification') {
          if (
            msg.attach.type === 'memberEnter'
            || msg.attach.type === 'memberExit'
          ) {
            this.getChatroomInfo()
            this.getChatroomMembers()
          }
        }
      })

      this.chat.msgs.push(...result)
      this.chat.msgsnum += result.length

      // 判断当前是否在最底部
      let needScroll = false

      if (this.chat.showChatroomMsgs) {
        const chatroom = this.$refs.chatroom.$el
        const chatroomrHeight = chatroom.getBoundingClientRect().height

        needScroll
          = chatroom.scrollTop + chatroomrHeight + 20 >= chatroom.scrollHeight
      }

      if (needScroll) {
        this.chatroomScrollToBottom()
      }
    },
    // 发送信息
    sendMsg (e) {
      if (e.shiftKey) {
        return
      }

      e.preventDefault()

      if (this.chat.inputMsg.trim() === '') {
        this.chat.inputMsg = ''
        return
      }

      this.$store
        .dispatch('chat/sendMsg', {
          msgType: 0,
          attach: this.chat.inputMsg,
          roomid: this.course.chatGroup,
        })
        .then(() => {
          console.log('<<<< SendText OK. >>>>')
        })
        .catch(() => {
          this.$Message.error('发送失败！')
        })

      this.chat.inputMsg = ''
    },
    // 发送表情
    sendExpression (id) {
      this.$store
        .dispatch('chat/sendMsg', {
          msgType: 100,
          roomid: this.course.chatGroup,
          attach: JSON.stringify({ type: 'expression', id }),
        })
        .then(() => {
          console.log('<<<< SendExpression OK. >>>>')
        })
        .catch(() => {
          this.$Message.error('表情发送失败！')
        })
    },
    // 发送礼物
    sendGift () {
      this.chat.allowSendGift = false

      this.$store
        .dispatch('chat/sendMsg', {
          msgType: 100,
          roomid: this.course.chatGroup,
          attach: JSON.stringify({ type: 'gift', id: this.chat.activeGift }),
        })
        .then(() => {
          this.chat.activeGift = ''
          this.chat.showChatroomGift = false
          this.chat.countdownStartTime = Date.now()
          this.startCountdown()
          console.log('<<<< SendGift OK. >>>>')
        })
        .catch(() => {
          this.chat.allowSendGift = true
          this.$Message.error('礼物发送失败！')
        })
    },
  },
  created () {
    this.getCourseDetail()

    if (!this.isLogin) {
      this.$Modal.confirm({
        title: '请先登录',
        onOk: () => {
          this.$router.push({ name: 'Login' })
        },
      })
    }
  },
  mounted () {
    // this.adjustPosition()
  },
  beforeDestroy () {
    // this.adjustPosition(true)

    if (nimInstance) {
      nimInstance.disconnect()
      nimInstance = null
    }

    if (chatroomInstance) {
      chatroomInstance.disconnect()
      chatroomInstance = null
    }
  },
}
</script>

<style lang="scss">
$msg-height: 44px;

#Debug {
  @include wh(1200px, 495px);
  position: relative;
  margin: 0 auto;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .media-video {
    @include wh(880px, 495px);
    @include pos(absolute, 0, auto, auto, 0);
  }

  main {
    @include wh(320px, 495px);
    @include pos(absolute, 0, 0, auto, auto);
  }

  .course-detail {
    @include pos(absolute, 0, 0, auto, 0, 1);
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;

    .title {
      @include font(20px, 26px, #000, bold);
    }

    .time {
      @include font(14px, 20px, #868688);
      margin-top: 10px;
    }

    .signup {
      margin-top: 16px;
    }

    .info {
      @include font(14px, 20px, #4a4a4a);
      margin-top: 16px;
      white-space: pre-wrap;
      overflow: hidden;
    }

    .btn {
      @include font(14px, 20px, #ed6c00);
      margin-top: 10px;
      padding: 0;
    }

    .course-files {
      margin: 0 20px;
    }
  }

  .chatroom-msgs {
    @include pos(absolute, 0, 0, auto, 0, 2);
    background-color: #f0f0f0;
    overflow-x: hidden;
    overflow-y: auto;

    .tabs {
      @include wh(100%, 44px);
    }

    .tab {
      @include wh(50%, 100%);
      border-radius: 0;
      background-color: #fff;

      &.active {
        background-color: #868688;
        color: #fff;
      }
    }

    .chatroom {
      @include pos(absolute, 88px, 0, 0, 0);
      padding: 0 10px;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .member {
      @include pos(absolute, 88px, 0, 0, 0);
      padding: 10px;
      overflow-x: hidden;
      overflow-y: auto;

      .member-item {
        @include wh(100%, 40px);
        padding: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      img {
        @include wh(30px, 30px);
        border-radius: 4px;
      }

      .name {
        @include font(14px, initial, #444);
        margin-left: 10px;
        flex-grow: 1;
        flex-shrink: 1;
      }

      .time {
        @include font(12px, initial, #868688);
        margin-left: 10px;
      }
    }

    .msg {
      position: relative;
      padding: 6px 50px;
      text-align: left;
      white-space: pre-wrap;
      word-break: break-all;

      .avatar {
        @include wh(40px, 40px);
        @include pos(absolute, 10px, auto, auto, 0);
        border-radius: 4px;
      }

      .username {
        @include font(12px, 17px, #8590a6);
      }

      .content {
        @include font(12px, 16px, #222);
        display: inline-block;
        padding: 8px;
        background-color: #ffffff;
        border-radius: 6px;
        display: inline-block;
        text-align: left;
      }

      .expression {
        @include wh(48px, 48px);
      }

      .gift-name {
        position: relative;
        padding-right: 36px;
      }

      .gift {
        @include wh(48px, 48px);
        @include pos(absolute, 50%, 0, auto, auto);
        transform: translate(50%, -50%);
      }

      &.self {
        text-align: right;

        img {
          left: auto;
          right: 0;
        }

        .content {
          background-color: #fff9c4;
        }

        .gift-name {
          padding-right: 10px;
          padding-left: 30px;
        }

        .gift {
          left: 0;
          transform: translate(-50%, -50%);
        }
      }
    }

    .close-chat {
      @include font(14px, 16px, #4a4a4a);
      padding: 14px 0;
      border-radius: 0;
      background-color: #ffffff;
      border: none;
      border-bottom: 1px solid #d8d8d8;
    }

    .ico-close-chat {
      color: #bcbcbc;
    }
  }

  .chatroom-input {
    @include wh(auto, 44px);
    @include pos(absolute, auto, 0, 0, 0, 2);
    padding: 6px;
    padding-right: 16px;
    border-top: 1px solid #d8d8d8;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    textarea {
      @include wh(auto, 100%);
      @include font(12px, 17px, rgba(0, 0, 0, 0.8));
      border: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(248, 248, 248, 0.82);
      padding: 6px 8px;
      border-radius: 3px;
      flex-grow: 1;
      resize: none;
      outline: none;
      overflow: hidden;

      &::-webkit-input-placeholder {
        color: rgba(0, 0, 0, 0.2);
      }
    }

    .tip-text {
      @include font(14px, initial, #4a4a4a);
      padding-left: 14px;
      flex-grow: 1;
    }

    .ico {
      margin-left: 16px;
      cursor: pointer;
    }

    .msgsnum {
      @include font(16px, 24px, #8590a6);
      margin-left: 4px;
      cursor: pointer;
    }
  }

  .chatroom-expression {
    @include wh(320px, 160px);
    @include pos(absolute, auto, auto, 0, 50%, 2);
    padding: 0 10px;
    transform: translateX(-50%);
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-content: space-around;

    img {
      @include wh(64px, 64px);
      flex-shrink: 0;
      flex-grow: 0;
      cursor: pointer;
    }
  }

  .chatroom-gifts {
    @include pos(absolute, auto, 0, 0, 0, 3);
    padding: 0 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: rgba(0, 0, 0, 0.8);

    .gift-list {
      display: flex;
      justify-content: space-between;
    }

    .gift-item {
      flex-shrink: 0;
      flex-grow: 0;
      text-align: center;

      img {
        @include wh(64px, 64px);
        border: 1px solid transparent;
        border-radius: 4px;
        cursor: pointer;

        &:hover,
        &.active {
          background-color: rgba(0, 0, 0, 0.2);
          border-color: rgba(255, 255, 255, 0.3);
        }
      }

      .name {
        @include font(12px, 14px, #fff);
        text-align: center;
      }
    }

    .control {
      margin-top: 12px;
      padding: 6px 0;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .time {
      @include font(12px, 22px, #fff, 500);
    }

    .btn-send {
      @include font(12px, 16px);
      padding: 2px 16px;
      border-radius: 16px;
    }
  }

  .need-login {
    @include pos(absolute, auto, 0, 0, 0, 4);
    background-color: #fff;
    padding: 10px;
    border-top: 1px solid #d8d8d8;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      @include font(14px, initial, #868688, 1px);
    }
  }
}
</style>
